import { useCallback, useState } from 'react'

type UseLocalFiltersOptions<Filters> = {
  filters: Filters
  initialFilters: Filters
  onChange: (filters: Filters, removeSort?: boolean) => void
  onRefresh: () => void
  onReset: () => void
}

export function useLocalFilters<Filters extends Record<string, unknown>>({
  filters,
  initialFilters,
  onChange,
  onRefresh,
  onReset,
}: UseLocalFiltersOptions<Filters>) {
  const [localFilters, setLocalFilters] = useState<Filters>(filters)
  const [isDirty, setIsDirty] = useState<boolean>(false)

  const handleFilterChange = useCallback(
    (filter: Partial<Filters>, submit?: boolean, removeSort?: boolean) => {
      const newFilters = { ...localFilters, ...filter }
      setLocalFilters(newFilters)

      if (submit) {
        onChange(newFilters, removeSort)
        setIsDirty(false)
        return
      }

      setIsDirty(true)
    },
    [localFilters, onChange],
  )

  const handleZoeken = useCallback(() => {
    if (isDirty) {
      onChange(localFilters)
      setIsDirty(false)
      return
    }

    onRefresh()
  }, [isDirty, localFilters, onChange, onRefresh])

  const handleReset = useCallback(() => {
    setLocalFilters(initialFilters)
    setIsDirty(false)
    onReset()
  }, [initialFilters, onReset])

  return {
    localFilters,
    isDirty,
    handleFilterChange,
    handleZoeken,
    handleReset,
    setLocalFilters,
  }
}
